module.exports = __webpack_public_path__ + "static/img/mzsm_font.1d614c8e.svg";